// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
  * {
    /* stylelint-disable-next-line declaration-no-important */
    text-shadow: none !important;
  }
  .nyleh0Dab4qr7E {
    display: none;
  }
}
.YOwVztHnQs1Bnp {
  margin-bottom: 0;
  padding: 16px;
  transition: opacity 0.3s ease;
  transition-delay: 0.2s;
  opacity: 1;
  font-size: 1.4em;
  gap: 8px;
}
.YOwVztHnQs1Bnp[data-hidden='true'] {
  opacity: 0;
}
@media (prefers-reduced-motion: reduce) {
  .YOwVztHnQs1Bnp {
    transition: none;
  }
}
.YOwVztHnQs1Bnp:hover,
.YOwVztHnQs1Bnp:active {
  background-color: transparent;
  color: var(--ds-text-selected, #0c66e4);
}
.WA2MQb3jCMsrhk {
  display: block;
  padding: 14px;
  border: 1px solid var(--ds-border-accent-blue, #1d7afc);
  background-color: var(--ds-surface, #ffffff);
  color: var(--ds-text, #172b4d);
  font-size: 1.4em;
  text-align: center;
  text-decoration: none;
}
.Ur8BpfSAjK4HCI {
  display: block;
  padding: 14px;
  border: 1px solid var(--ds-border-accent-blue, #1d7afc);
  background-color: var(--ds-surface, #ffffff);
  color: var(--ds-text, #172b4d);
  text-align: center;
  text-decoration: none;
  border-color: var(--ds-border-accent-blue, #1d7afc);
  background-color: var(--ds-link, #0c66e4);
  color: var(--ds-text-inverse, #ffffff);
  font-size: 1.4em;
}
.Ur8BpfSAjK4HCI:active {
  border-color: var(--ds-border-accent-blue, #0747a6);
  background-color: var(--ds-link-pressed, #0747a6);
}
.qgtV4TUUes3NZj {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.vfDDArYWGrpeSL {
  position: fixed;
  z-index: 90;
  top: 0;
  box-sizing: border-box;
  width: 100%;
  height: 70px;
  overflow: hidden;
  transition: height 0.3s linear, box-shadow 0.3s linear 0.3s, background-color 0.3s linear 0.3s;
  background-color: var(--ds-surface, #ffffff);
  box-shadow: var(--ds-shadow-overlay, 0px 8px 12px #091e4226, 0px 0px 1px #091e424f);
}
.vfDDArYWGrpeSL * {
  box-sizing: border-box;
  font-family: 'Charlie Text', var(--ds-font-family-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
}
.vfDDArYWGrpeSL[data-open='true'] {
  height: 100%;
  transition: height 0.3s linear 0.1s, box-shadow 0.1s linear, background-color 0.1s linear;
}
@media (prefers-reduced-motion: reduce) {
  .vfDDArYWGrpeSL[data-open='true'] {
    transition: none;
  }
}
@media (min-width: 992px) {
  .vfDDArYWGrpeSL {
    display: none;
  }
}
@media (prefers-reduced-motion: reduce) {
  .vfDDArYWGrpeSL {
    transition: none;
  }
}
.ARyxrL8buPgCNR {
  font-size: 1.4em;
  text-decoration: none;
}
.ARyxrL8buPgCNR:hover,
.ARyxrL8buPgCNR:active {
  color: var(--ds-text-selected, #0c66e4);
}
.zeUOmffcaTK_Ye {
  transition: all 0.3s ease;
  transition-delay: 0.2s;
  opacity: 1;
}
.zeUOmffcaTK_Ye[data-hidden='true'] {
  margin-left: -141.69px;
  opacity: 0;
}
@media (prefers-reduced-motion: reduce) {
  .zeUOmffcaTK_Ye {
    transition: none;
  }
}
.XUy6tTJaK1zSSk {
  margin: 0 0 0 auto;
  padding: 14px;
}
.XUy6tTJaK1zSSk:hover,
.XUy6tTJaK1zSSk:active {
  background-color: transparent;
}
.Oa6yIjvPmgBtfx {
  display: flex;
  z-index: 100;
  align-items: center;
  justify-content: space-between;
  height: 70px;
}
@media (min-width: 992px) {
  .Oa6yIjvPmgBtfx {
    height: 60px;
  }
}
.rccuqAZzKSQW8W {
  display: flex;
  position: absolute;
  top: 70px;
  bottom: 0;
  left: 0;
  flex-direction: column;
  width: 100%;
  padding: 0 14px 14px;
  overflow: auto;
  transition: left 0.4s ease;
  background-color: var(--ds-surface, #ffffff);
  gap: 14px;
}
.rccuqAZzKSQW8W h2 {
  margin-bottom: 0;
}
.rccuqAZzKSQW8W h2,
.rccuqAZzKSQW8W h3 {
  color: var(--ds-text, #172b4d);
  font-size: 16px;
  font-weight: 500;
}
.rccuqAZzKSQW8W p:last-child {
  margin-bottom: 0;
}
.rccuqAZzKSQW8W[data-offscreen='left'] {
  left: -100vw;
}
.rccuqAZzKSQW8W[data-offscreen='right'] {
  left: 100vw;
}
@media (prefers-reduced-motion: reduce) {
  .rccuqAZzKSQW8W {
    transition: none;
  }
}
.D4GMgQiZjrMayt {
  transition: opacity 0.6s ease;
  transition-delay: 0.1s;
  opacity: 0;
}
.D4GMgQiZjrMayt[data-open='true'] {
  opacity: 1;
}
@media (prefers-reduced-motion: reduce) {
  .D4GMgQiZjrMayt {
    transition: none;
  }
}
.Qg9eSj4KT1aHrD {
  justify-content: space-between;
  margin-bottom: 0;
  padding: 0 8px 0 0;
  font-size: 1.4em;
}
.Qg9eSj4KT1aHrD:hover,
.Qg9eSj4KT1aHrD:active {
  border-bottom: 1px solid var(--ds-border, #091e4224);
  background-color: transparent;
  color: var(--ds-text-selected, #0c66e4);
}
.loS9mRs0uHNiMo {
  border-top: 1px solid var(--ds-border, #091e4224);
}
.loS9mRs0uHNiMo > * {
  display: flex;
  align-items: center;
  min-height: 70px;
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noPrint": `nyleh0Dab4qr7E`,
	"backButton": `YOwVztHnQs1Bnp`,
	"buttonLink": `WA2MQb3jCMsrhk`,
	"buttonLinkPrimary": `Ur8BpfSAjK4HCI`,
	"buttons": `qgtV4TUUes3NZj`,
	"header": `vfDDArYWGrpeSL`,
	"tabLink": `ARyxrL8buPgCNR`,
	"logoWrapper": `zeUOmffcaTK_Ye`,
	"menuButton": `XUy6tTJaK1zSSk`,
	"navBar": `Oa6yIjvPmgBtfx`,
	"page": `rccuqAZzKSQW8W`,
	"pageContainer": `D4GMgQiZjrMayt`,
	"tabButton": `Qg9eSj4KT1aHrD`,
	"tabList": `loS9mRs0uHNiMo`
};
export default ___CSS_LOADER_EXPORT___;
